import { React, useState } from 'react';
import getBackend from 'backend/backend';
import { useTranslation } from "react-i18next";
import { Container, Form, Button, Alert } from 'react-bootstrap';
import SidebarPage from 'components/sidebar_page';

const AddWorker = () => {
    const [t] = useTranslation('common');
    const defaultModel = "deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B";
    const [model, setModel] = useState(defaultModel);
    const [numGpus, setNumGpus] = useState(1);
    const [modelsStoragePath, setModelsStoragePath] = useState("/workspace/models");
    const [contextSize, setContextSize] = useState(32768);
    const [quantization, setQuantization] = useState("fp8");
    const [extraArgs, setExtraArgs] = useState("");
    const [configId, setConfigId] = useState("");
    const [error, setError] = useState(null);
    const [useCustomModel, setUseCustomModel] = useState(false);
    const [vramSize, setVramSize] = useState(0);

    const validateParameters = () => {
        if (!model || model.trim() === '') {
            setError(t('Model name is required'));
            return false;
        }

        if (!numGpus || parseInt(numGpus) <= 0) {
            setError(t('Number of GPUs must be a positive number'));
            return false;
        }

        if (!modelsStoragePath || modelsStoragePath.trim() === '' || !modelsStoragePath.startsWith('/')) {
            setError(t('Models storage path is required'));
            return false;
        }

        if (!contextSize || contextSize <= 0) {
            setError(t('Context size must be a positive number'));
            return false;
        }

        if (!quantization) {
            setError(t('Quantization must be selected'));
            return false;
        }

        return true;
    }

    return (
        <SidebarPage title={t('Add Worker')} description={t('Add Worker')}>
            <Container className="my-5">

                <div className="mt-4">
                    <h2>{t('Add Worker To Run a Model')}</h2>

                    <Form className="mb-3">
                        {!useCustomModel &&
                        <Form.Group>
                            <Form.Label>{t('Select Model')}</Form.Label>
                            <Form.Select
                                id="modelSelect"
                                value={model}
                                onChange={(e) => {
                                    setModel(e.target.value);
                                }}
                            >
                                <option value="deepseek-ai/DeepSeek-R1-Distill-Qwen-1.5B">DeepSeek-R1-Distill-Qwen-1.5B</option>
                                <option value="deepseek-ai/DeepSeek-R1-Distill-Qwen-32B">DeepSeek-R1-Distill-Qwen-32B</option>
                                <option value="deepseek-ai/DeepSeek-R1-Distill-Llama-70B">DeepSeek-R1-Distill-Llama-70B</option>
                                <option value="Qwen/Qwen2.5-Coder-32B-Instruct">Qwen2.5-Coder-32B-Instruct</option>
                                <option value="Qwen/Qwen2.5-32B-Instruct">Qwen2.5-32B-Instruct</option>
                                <option value="Qwen/Qwen2.5-72B-Instruct">Qwen2.5-72B-Instruct</option>
                                <option value="Qwen/Qwen2.5-7B-Instruct">Qwen2.5-7B-Instruct</option>
                                <option value="Qwen/Qwen2.5-VL-7B-Instruct">Qwen2.5-VL-7B-Instruct</option>
                                <option value="Qwen/Qwen2.5-VL-72B-Instruct">Qwen2.5-VL-72B-Instruct</option>
                            </Form.Select>
                        </Form.Group>
                        }

                        <Form.Check
                            type="checkbox"
                            label={t('Use Custom Model')}
                            checked={useCustomModel}
                            onChange={(e) => {
                                setModel("");
                                setUseCustomModel(e.target.checked)
                                if (!e.target.checked) {
                                    setModel(defaultModel);
                                }
                            }}
                        />

                        {useCustomModel &&
                        <Form.Group>
                            <Form.Label>{t('Custom Model Name')}</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter model name (e.g. organization/model-name)"
                                onChange={(e) => setModel(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                                {t('Enter the full model identifier as it appears in Hugging Face')}
                            </Form.Text>
                        </Form.Group>
                        }

                        <Form.Group>
                            <Form.Label>{t('Number of GPUs')}</Form.Label>
                            <Form.Select
                                value={numGpus}
                                onChange={(e) => setNumGpus(parseInt(e.target.value))}
                            >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="4">4</option>
                                <option value="8">8</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Models Storage Path')}</Form.Label>
                            <Form.Control
                                type="text"
                                value={modelsStoragePath}
                                onChange={(e) => setModelsStoragePath(e.target.value)}
                            />
                            <Form.Text className="text-muted">
                                {t('Enter the full path to the directory (starting with /) where the models will be downloaded and stored')}
                            </Form.Text>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Context Size')}</Form.Label>
                            <Form.Select
                                value={contextSize}
                                onChange={(e) => setContextSize(parseInt(e.target.value))}
                            >
                                <option value="4096">4096</option>
                                <option value="8192">8192</option>
                                <option value="16384">16384</option>
                                <option value="32768">32768</option>
                                <option value="65536">65536</option>
                                <option value="131072">131072</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Quantization')}</Form.Label>
                            <Form.Select
                                value={quantization}
                                onChange={(e) => setQuantization(e.target.value)}
                            >
                                <option value="fp8">fp8</option>
                                <option value="None">None</option>
                            </Form.Select>
                        </Form.Group>

                        <Form.Group>
                            <Form.Label>{t('Extra Args To vLLM')}</Form.Label>
                            <Form.Control
                                type="text"
                                value={extraArgs}
                                onChange={(e) => setExtraArgs(e.target.value)}
                            />
                        </Form.Group>

                        <Form.Group>
                            <Button className="my-3 custom-button" variant="light" onClick={async () => {
                                if (!validateParameters()) {
                                    return;
                                }
                                setError(null);
                                const result = await getBackend().postWorkerConfig({
                                    model: model,
                                    num_gpus: numGpus,
                                    models_storage_path: modelsStoragePath,
                                    context_size: contextSize,
                                    quantization: quantization,
                                    extra_args: extraArgs,
                                });
                                if (result.error == null) {
                                    setConfigId(result.response.id);
                                    setVramSize(result.response.vram_size);
                                } else {
                                    setError(result.error);
                                }
                                }}>
                                {t('Create Worker Configuration')}
                            </Button>
                        </Form.Group>
                    </Form>
                    {error && <Alert variant="danger">{error}</Alert>}
                    {configId &&
                    <>
                        {vramSize > 0 &&
                            <Alert variant="info" className="mt-3">
                                <i className="bi bi-gpu-card me-2"></i>
                                <strong>{t('Estimated required total GPU VRAM size:')}</strong> {vramSize} {t('GB')}
                            </Alert>
                        }
                        <h2 className="mt-4 mb-3">{t('To add a new worker, run the following commands on your host machine:')}</h2>
                        <div className="position-relative">
                            <pre className="bg-light p-3 border rounded shadow-sm">
                                <code id="installCommand" className="d-block">
                                    curl -sSL {window.location.origin}/localiq_worker_install.sh | bash -s -- --config {window.location.origin}/api/worker/config/{configId}
                                </code>
                            </pre>
                            <Button
                                variant="outline-secondary"
                                size="sm"
                                className="position-absolute top-0 end-0 m-2"
                                onClick={() => {navigator.clipboard.writeText(`curl -sSL ${window.location.origin}/localiq_worker_install.sh | bash -s -- --config ${window.location.origin}/api/worker/config/${configId}`)}}
                                title={t('Copy to clipboard')}
                            >
                                <i className="bi bi-clipboard"></i>
                            </Button>
                        </div>
                        {process.env.REACT_APP_ENV_TYPE === "onpremise" &&
                            <>
                                <p>{t('If you need to skip certificate validation (for self-signed certificates):')}</p>
                                <pre className="bg-light p-3 border rounded">
                                    <code id="installCommandInsecure">
                                        curl -sSL -k {window.location.origin}/localiq_worker_install.sh | bash -s -- --config {window.location.origin}/api/worker/config/{configId} --insecure-connection
                                    </code>
                                </pre>
                            </>
                        }
                        <p className="mt-2">
                            {t('The installer will download and configure the worker service with the selected model automatically.')}
                        </p>
                    </>
                    }


                </div>


            </Container>
        </SidebarPage>
    );
};

export default AddWorker;
